import applicationTabService from '@services/requests/application-tab.service';
import { setBeamShape } from '@reducers/options/beam/actions';
import { setBarrierShape } from '@reducers/options/barrier/actions';
import { APP_TYPES } from '@config';
import { defaultProfileState } from './index';
import { setProfileType } from '@reducers/actions';
import { standardList } from './../../../../src/app.values';
import Scene from '@scene';

export const SET_MATERIAL_NAMES = 'SET_MATERIAL_NAMES';
export const SET_PROFILE_TYPES = 'SET_PROFILE_TYPES';
export const SET_PROFILE_SIZES = 'SET_PROFILE_SIZES';
export const SET_PROFILE_SHAPE = 'SET_PROFILE_SHAPE';
export const SET_SPINNER = 'SET_SPINNER';

export const SET_PROFILE_STATE = 'SET_PROFILE_STATE';
export const RESET_PROFILE_STATE = 'RESET_PROFILE_STATE';

/*
  Action creators
 */
export function resetProfileState() {
  return (dispatch, getState) => {
    dispatch({ type: RESET_PROFILE_STATE });
    dispatch(setProfileType(getState().main.localization.profileType));
  };
}
export function setProfileState(state) {
  return { type: SET_PROFILE_STATE, state };
}
export function initProfile() {
  return (dispatch, getState) => {
    if (getState().main.appType !== APP_TYPES.REBAR_REINFORCEMENT && 
        Number(getState().main.localization.designStandard) !== standardList["Masonry"]) {
      const { family, size } = 
        defaultProfileState[getState().main.appType || APP_TYPES.GENERAL_CALCULATION][getState().main.localization.profileType || 0];
  
      return dispatch(getProfileShape(family, size));
    }
  };
}

export function getMaterialNames(cb) {
  return dispatch => {
    return applicationTabService.getMaterialNames()
      .then(async (materialNames) => {
        if (materialNames) {
          if (cb)
          {
            await dispatch({ type: SET_MATERIAL_NAMES, value: materialNames });
            cb(materialNames);
          }
          else {
            dispatch({ type: SET_MATERIAL_NAMES, value: materialNames });
          }
        }

        return materialNames;
      });
  };
}

export function getProfileTypes(cb) {
  return (dispatch, getState) => {
    return applicationTabService.getProfileTypes(getState().main.appType)
      .then(async (profileTypes) => {
        if (profileTypes) {
          if (cb)
          {
            await dispatch({ type: SET_PROFILE_TYPES, value: profileTypes });
            cb(profileTypes);
          }
          else {
            dispatch({ type: SET_PROFILE_TYPES, value: profileTypes });
          }
        }

        return profileTypes;
      });
  };
}

export function getProfileSizes(profile, cb) {
  return (dispatch) => {
    return applicationTabService.getProfileSizes(profile)
      .then(async (profileSizes) => {
        if (profileSizes) {
          if (cb)
          {
            await dispatch({ type: SET_PROFILE_SIZES, value: profileSizes });
            cb(profileSizes);
          }
          else {
            dispatch({ type: SET_PROFILE_SIZES, value: profileSizes });
          }
        }

        return profileSizes;
      });
  };
}

export function getProfileShape(type, size, resetCamera = false) {
  return dispatch => {
    if (type && size) {
      return applicationTabService.getProfileShape(type, size)
        .then(data => {
          if (data) {
            const shape = {
              center: {},
              inner: [],
              outer: []
            };

            if (data['Center']) {
              shape.center = {
                x: data['Center']['X'],
                y: data['Center']['Y']
              };
            }

            if (data['InnerContour']) {
              shape.inner = data['InnerContour'].map(list => list.map(i => ({x: i['X'], y: i['Y']})));
            }
            else {
              shape.inner = [];
            }

            if (data['OuterContour']) {
              shape.outer = data['OuterContour'].map(i => ({ x: i['X'], y: i['Y'] }));
            }
            else {
              shape.outer = [];
            }

            if(shape.outer &&shape.outer.length) {
              dispatch({ type: SET_PROFILE_SHAPE, value: shape });
              dispatch(setBeamShape(shape));
              dispatch(setBarrierShape(shape));
              if (resetCamera) // only after loading the profile on a new application (mostly for bracket)
                setTimeout(() => Scene.resetCamera());
            }
            
          }

          return data;
        });
    }
  };
}

export function setSpinner (isSpinning) {
  return (dispatch) => {
      dispatch({ type: SET_SPINNER, isSpinning: isSpinning });
  };
}



// WEBPACK FOOTER //
// ./src/reducers/web-services/profile/actions.js